const urls = {
  base: '/change_password/',
};

export function changePasswordUrl() {
  return urls.base;
}

export default urls;